export default __webpack_public_path__ + "static/media/goapp_logo_white.a2cc2b2a.svg";